<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M3.5 38.5L28 29.75L12.25 14L3.5 38.5ZM21.6125 28.315L9.275 32.725L13.685 20.3875L21.6125 28.315Z" fill="#071689"/>
        <path d="M25.4273 21.9275L35.2098 12.145C36.0673 11.2875 37.4498 11.2875 38.3073 12.145L39.3398 13.1775L41.1948 11.3225L40.1623 10.29C38.2898 8.4175 35.2273 8.4175 33.3548 10.29L23.5723 20.0725L25.4273 21.9275Z" fill="#32DAC3"/>
        <path d="M17.6048 12.04L16.5723 13.0725L18.4273 14.9275L19.4598 13.895C21.3323 12.0225 21.3323 8.95999 19.4598 7.08749L18.4273 6.05499L16.5723 7.92749L17.6048 8.95999C18.4448 9.79999 18.4448 11.2 17.6048 12.04Z" fill="#32DAC3"/>
        <path d="M29.8548 20.79L27.0723 23.5725L28.9273 25.4275L31.7098 22.645C32.5673 21.7875 33.9498 21.7875 34.8073 22.645L37.6248 25.4625L39.4798 23.6075L36.6623 20.79C34.7723 18.9175 31.7273 18.9175 29.8548 20.79Z" fill="#32DAC3"/>
        <path d="M26.3548 10.29L20.0723 16.5725L21.9273 18.4275L28.2098 12.145C30.0823 10.2725 30.0823 7.20999 28.2098 5.33749L25.4273 2.55499L23.5723 4.40999L26.3548 7.19249C27.1948 8.04999 27.1948 9.44999 26.3548 10.29Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "GiftIcon",

    props: {
        width: {
            type: Number,
            default: 42
        },

        height: {
            type: Number,
            default: 42
        },

        classes: {
            type: String
        }
    }
}
</script>
